import dayjs from 'dayjs';
import { z } from 'zod';

export const projectSchema = z
  .object({
    name: z.string().min(1, 'Project name is required'),
    description: z.string().min(1, 'Project description is required'),
    priority: z.string().min(1, 'Project priority is required'),
    slack_channel: z
      .string()
      .url('Slack channel must be a valid URL')
      .refine((url) => url.includes('slack.com'), {
        message: 'Slack channel must be a Slack URL',
      })
      .optional()
      .or(z.literal('')),
    start_date: z.string().nonempty('Start date is required'),
    end_date: z.string().nonempty('End date is required'),
    // team_id: z.string().min(1, 'You must assign a team to this project.'),
    files: z
      .array(z.instanceof(File))
      .min(1, 'At least one file is required')
      .max(5, 'You can upload a maximum of 5 files'),
    // prd_file: z
    //   .union([
    //     z.instanceof(File),
    //     z.record(z.never()),
    //   ])
    //   .optional(),
    // tech_spec_file: z
    //   .union([
    //     z.instanceof(File),
    //     z.record(z.never()),
    //   ])
    //   .optional(),
  })
  .refine((data) => dayjs(data.end_date).isAfter(dayjs(data.start_date)), {
    message: 'End date must be after start date',
    path: ['end_date'],
  });

export const slackChannelSchema = z
  .string()
  .url('Invalid Slack channel URL')
  .refine((url) => url.includes('slack.com'), {
    message: 'Slack channel must be a Slack URL',
  })
  .optional()
  .or(z.literal(''));

// Inferred TypeScript types from Zod schemas
export type ProjectFormData = z.infer<typeof projectSchema>;
export type SlackChannel = z.infer<typeof slackChannelSchema>;
